<template>
    <div  class="table-box" v-if="tableData.length>0">
        <table style="width:100%"  border="1" cellspacing="0">
            <tr>
                <th v-for="(thItem,thIndex) in thList" :key="thIndex">{{thItem}}</th>
            </tr>
            <tr v-for="(item,index) in tableData" :key="index" class="table-list">
                <td>{{item.flowNo}}</td>
                <td>{{item.orderNo}}</td>
                <td>{{item.flowTypeText}}</td>
                <td>{{item.flowAmount}}</td>
                <td>{{item.gmtCreate}}</td>
                <td>{{item.operationName}}</td>
            </tr>
        </table>
    </div>
</template>
<script>
export default {
    data(){
        return{
            thList:['流水号','业务单号','交易类型','金额','交易时间','操作人'],
        }
    },
    props:{
        tableData:{
            type:Array,
            default:[]
        }
    }
}
</script>
<style lang="less" scoped>
.table-box{
        padding: 10px;
        table{
            border-collapse: collapse;
        }
        tr,td,th{
            text-align: center; 
            border: 1px solid #dfdfdf;
            font-size: 13px;
            padding: 10px 0;
        }
        .table-list{
            &:hover{
                background: #f5f7fa
            }
        }
        .table-name{
            text-align: left;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            line-clamp: 2;
            word-wrap: break-all;
        }
        .el-button{
            margin: 0
        }
    }
</style>
